import { useCallback, useState } from 'react';
import { MaintenanceStatus } from 'services/maintenanceEngine';

export type MaintenanceTabType =
  | 'Dashboard'
  | 'Asset Due'
  | 'Upcoming Maintenance'
  | 'Completed Maintenance'
  | 'Maintenance History'
  | 'Reports';

export const useInjection = () => {
  const [tab, setTab] = useState<MaintenanceTabType>('Dashboard');
  const [historyStatusFilter, setHistoryStatusFilter] = useState<MaintenanceStatus | undefined>();

  const handleChangeTab = useCallback((value: MaintenanceTabType) => {
    setHistoryStatusFilter(undefined);
    setTab(value);
  }, []);

  const navigateToTab = useCallback(
    (value: MaintenanceTabType, statusFilter?: MaintenanceStatus) => {
      setHistoryStatusFilter(statusFilter);
      setTab(value);
    },
    []
  );

  return {
    tab,
    setTab: handleChangeTab,
    navigateToTab,
    historyStatusFilter
  };
};
